/**
 * ModuleContext — global state for the "current module" (LV vs Electrical).
 * Persists to localStorage. All pages that want to filter by module
 * (Dashboard, Projects, Sidebar badge, etc.) read from here.
 *
 * The UI shows a dedicated Module Switcher (top bar) so the user is ALWAYS
 * aware of which module they're looking at. LV and Electrical never mix
 * on the same list visually.
 */
import { createContext, useContext, useEffect, useState } from "react";

const LS_KEY = "iqes_module";
const Ctx = createContext(null);

export function ModuleProvider({ children }) {
  const [module, setModuleState] = useState(() => {
    try { return localStorage.getItem(LS_KEY) || "low_voltage"; }
    catch { return "low_voltage"; }
  });

  const setModule = (m) => {
    setModuleState(m);
    try { localStorage.setItem(LS_KEY, m); } catch {}
  };

  useEffect(() => {
    document.body.dataset.module = module;
  }, [module]);

  const meta = module === "electrical"
    ? { key: "electrical", labelEs: "Eléctrico", labelEn: "Electrical", color: "#EAB308" }
    : { key: "low_voltage", labelEs: "Bajo Voltaje", labelEn: "Low Voltage", color: "#003366" };

  return (
    <Ctx.Provider value={{ module, setModule, meta }}>
      {children}
    </Ctx.Provider>
  );
}

export const useModule = () => useContext(Ctx);
